import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const UploadIcon = React.memo(
  ({ fill = variables['colors-mc-primary'], width = 70, viewBox = '0 0 70 50' }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={remCss(width)}
      height={remCss(width * 50 / 70)}
      viewBox={viewBox}
    >
      <g clipPath="url(#clip0_3274_7439)">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M48.4242 9.45713C55.7236 3.93341 66.3608 10.3731 66.3608 17.1161C66.3608 21.4711 64.6919 23.1793 62.107 24.9999C75.1437 31.9734 69.2435 47.3982 57.8701 49.9999H18.1477C-0.508138 49.9999 -7.40856 24.719 12.4554 18.594C8.72989 3.74236 37.8432 -9.66514 48.4242 9.45713ZM30.4651 39.0761V30.1528H22.4802L35.0055 15.082L47.5307 30.1528H39.5458V39.0761H30.4651Z"
            fill={fill}/>
      </g>
      <defs>
        <clipPath id="clip0_3274_7439">
          <rect width="69.0492" height="50" fill="white" transform="translate(0.475342)"/>
        </clipPath>
      </defs>

    </svg>
  ),
);
UploadIcon.displayName = 'UploadIcon';

export default UploadIcon;
